/* CONSTS INJECTION */
;
const PUBLIC_PATH="/assets/";
/* VARS INJECTION */
;
/* LETS INJECTION */
;
import $ from './libs/jquery';
window.$ = window.jQuery = $;

require('./libs/slick.min');

(function (factory) {
  if (document.readyState === 'loading') {
    return document.addEventListener('DOMContentLoaded', factory);
  }

  return factory();
})(function () {
  require("./js/main");

  console.log("Application ready!");
});